import React from 'react';

import type {
  LayoutType,
  PlacementId,
  RecommendationCategories
} from '@schibsted-nmp/advertising-shared';

import type { AdSlot, ContainerId } from '../index.js';

export function AdvertisingWebComponent(props: AdvertisingWebComponent.Props) {
  return <AdvertisingWebComponent.Forwarded {...props} />;
}

export namespace AdvertisingWebComponent {
  export type Props = React.ComponentProps<typeof Forwarded>;

  export const Forwarded = React.forwardRef<HTMLDivElement, Forwarded.Props>(
    (
      { placementId, adIndex, initialLayoutType, categories, containerId },
      ref
    ) => (
      <advt-component
        containerId={containerId}
        initialLayoutType={initialLayoutType}
        categories={categories}
        adIndex={adIndex}
        placementId={placementId}
      >
        <div
          ref={ref}
          id={`${placementId}--container` satisfies ContainerId}
          slot={`${placementId}--slot` satisfies AdSlot}
        ></div>
      </advt-component>
    )
  );

  export namespace Forwarded {
    export type Props = {
      placementId: PlacementId;
      containerId?: string | undefined;
      adIndex?: number | undefined;

      /** The categories of the item to get the `placementId` for. */
      categories?: RecommendationCategories | undefined;

      /** The initial layout type of the item to get the `placementId` for. (Grid or List) */
      initialLayoutType?: LayoutType | undefined;
    };
  }
}
